// ** Types
import { BlankLayoutProps } from './types'

const BlankLayout = ({ children }: BlankLayoutProps) => {
  return (
    <div className="layout-wrapper h-screen [&_.content-center]:flex [&_.content-center]:min-h-screen [&_.content-center]:items-center [&_.content-center]:justify-center [&_.content-center]:p-10 [&_.content-right]:flex [&_.content-right]:min-h-screen [&_.content-right]:overflow-x-hidden [&_.content-right]:relative">
      <div className="app-content min-h-screen overflow-x-hidden relative">
        {children}
      </div>
    </div>
  )
}

export default BlankLayout
